import emailjs from '@emailjs/browser';

// EmailJS Configuration
// These values come from environment variables
export const EMAILJS_CONFIG = {
  SERVICE_ID: import.meta.env.VITE_EMAILJS_SERVICE_ID || 'your_service_id',
  TEMPLATE_ID: import.meta.env.VITE_EMAILJS_TEMPLATE_ID || 'your_template_id',
  PUBLIC_KEY: import.meta.env.VITE_EMAILJS_PUBLIC_KEY || 'your_public_key',
};

// Initialize EmailJS (optional - can be done in component)
export const initEmailJS = () => {
  emailjs.init(EMAILJS_CONFIG.PUBLIC_KEY);
};

// Email sending function
export interface EmailData {
  from_name: string;
  from_email: string;
  company?: string;
  subject: string;
  message: string;
  to_name?: string;
}

export const sendEmail = async (data: EmailData): Promise<void> => {
  try {
    const templateParams = {
      from_name: data.from_name,
      from_email: data.from_email,
      company: data.company || 'Not specified',
      subject: data.subject,
      message: data.message,
      to_name: 'Jeremy Marino', // Your name
      reply_to: data.from_email,
    };

    const response = await emailjs.send(
      EMAILJS_CONFIG.SERVICE_ID,
      EMAILJS_CONFIG.TEMPLATE_ID,
      templateParams,
      EMAILJS_CONFIG.PUBLIC_KEY
    );

    if (response.status !== 200) {
      throw new Error(`EmailJS failed with status: ${response.status}`);
    }

    console.log('Email sent successfully:', response);
  } catch (error) {
    console.error('Failed to send email:', error);
    throw error;
  }
};

// Alternative: Direct emailjs usage without wrapper
export const sendEmailDirect = async (formData: {
  name: string;
  email: string;
  company: string;
  subject: string;
  message: string;
}): Promise<void> => {
  const templateParams = {
    from_name: formData.name,
    from_email: formData.email,
    company: formData.company || 'Not specified',
    subject: formData.subject,
    message: formData.message,
    to_name: 'Jeremy Marino',
    reply_to: formData.email,
  };

  const response = await emailjs.send(
    EMAILJS_CONFIG.SERVICE_ID,
    EMAILJS_CONFIG.TEMPLATE_ID,
    templateParams,
    EMAILJS_CONFIG.PUBLIC_KEY
  );

  if (response.status !== 200) {
    throw new Error(`EmailJS failed with status: ${response.status}`);
  }
};
